export default "__VITE_ASSET__3cf6ca4e__"